import { Linkedin, Instagram, Award, Home, GraduationCap } from "lucide-react";
import { IMAGES, CONTACT, FOUNDER } from "@/data/site";
import { FadeUp, Chapter, RevealLines, ImageReveal } from "./motion";

const ACH_ICONS = [GraduationCap, Home, Award];

export default function Founder() {
  return (
    <section id="about" data-testid="founder-section" className="bg-[#E7DDD0]/50 py-24 md:py-36">
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-16 px-6 md:px-12 lg:grid-cols-[1fr_1.2fr]">
        <div className="relative">
          <ImageReveal
            src={IMAGES.founder}
            alt="Sohan Raju — Founder, Bengaluru Interiors"
            className="aspect-[9/16] rounded-2xl"
            imgClass="object-top"
          />
          <FadeUp delay={0.5} className="glass absolute -bottom-8 -right-4 rounded-xl border hairline px-6 py-5 shadow-[0_8px_32px_rgba(27,27,27,0.08)] md:-right-10">
            <p className="font-num text-3xl font-semibold text-[#1B1B1B]">2020</p>
            <p className="text-[10px] uppercase tracking-[0.25em] text-[#2C2C2C]/55">Crafting Since</p>
          </FadeUp>
        </div>

        <div>
          <Chapter num="08" title="The Founder" />
          <RevealLines
            className="mt-8 font-display text-4xl tracking-tight text-[#1B1B1B] md:text-6xl"
            lines={[<>Sohan <span className="italic text-[#B68D40]">Raju</span></>]}
          />
          <FadeUp delay={0.3}>
            <p className="mt-8 max-w-xl text-base leading-relaxed text-[#2C2C2C]/75">
              {FOUNDER.bio1}
            </p>
            <p className="mt-4 max-w-xl text-base leading-relaxed text-[#2C2C2C]/75">
              {FOUNDER.bio2}
            </p>
            <p className="mt-6 font-serif2 text-lg italic text-[#B68D40]">{FOUNDER.motto}</p>
          </FadeUp>

          <div className="mt-10 space-y-4">
            {FOUNDER.achievements.map((text, i) => {
              const Icon = ACH_ICONS[i];
              return (
                <FadeUp key={i} delay={0.4 + i * 0.1}>
                  <div data-testid={`founder-achievement-${i}`} className="flex items-center gap-4">
                    <span className="flex h-10 w-10 items-center justify-center rounded-full border hairline-gold text-[#B68D40]">
                      <Icon size={16} />
                    </span>
                    <p className="text-sm text-[#2C2C2C]/75">{text}</p>
                  </div>
                </FadeUp>
              );
            })}
          </div>

          <FadeUp delay={0.7} className="mt-10 flex flex-wrap items-center gap-6">
            <span className="font-sign text-4xl text-[#1B1B1B]">Sohan Raju</span>
            <div className="flex gap-3">
              <a href={CONTACT.linkedin} target="_blank" rel="noreferrer" data-testid="founder-linkedin-btn" className="flex h-11 w-11 items-center justify-center rounded-full border hairline text-[#1B1B1B] transition-colors duration-300 hover:bg-[#1B1B1B] hover:text-[#F7F5F2]" aria-label="LinkedIn">
                <Linkedin size={17} />
              </a>
              <a href={CONTACT.instagram} target="_blank" rel="noreferrer" data-testid="founder-instagram-btn" className="flex h-11 w-11 items-center justify-center rounded-full border hairline text-[#1B1B1B] transition-colors duration-300 hover:bg-[#1B1B1B] hover:text-[#F7F5F2]" aria-label="Instagram">
                <Instagram size={17} />
              </a>
            </div>
          </FadeUp>
        </div>
      </div>
    </section>
  );
}
